import { Paper } from 'shared/ui/paper'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const SelectNightsCountSkeleton = () => {
  return (
    <div className={s.container}>
      <div className={s.tabs}>
        <Skeleton className={s.tab} />
        <Skeleton className={s.tabActive} />
      </div>

      <div className={s.flexibleDeparture}>
        <Skeleton className={s.flexibleBlock} />
      </div>

      <Paper
        padding={[14, 16]}
        className={s.list}
      >
        {Array.from({ length: 10 }).map((_, index) => (
          <div
            key={index}
            className={s.item}
          >
            <Skeleton className={s.text} />
            <Skeleton className={s.radio} />
          </div>
        ))}
      </Paper>
    </div>
  )
}
